import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { message } from "antd";
import { notifyError } from "../../utils/notification";
import { routesConfig } from "../routes";
import { generateRequestHash } from "../../utils/hashSha256";

export const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}v2`;

export const axiosConfigV2 = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    ...(localStorage.getItem("browserExamKey")
      ? {
          "x-safeexambrowser-requesthash":
            localStorage.getItem("browserExamKey"),
        }
      : {}),
  },
});

axiosConfigV2.interceptors.request.use(
  async (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const isSeb = navigator.userAgent.includes("SEB");
    if (isSeb) {
      try {
        const fullUrl = config.baseURL
        ? `${config.baseURL.replace(/\/$/, "")}${config.url}`
        : config.url || "";
        
        const hashKey = await generateRequestHash(fullUrl);

        if(hashKey) {
          config.headers["X-SafeExamBrowser-RequestHash"] = hashKey;
        }
      } catch (err) {
        console.error("Không thể thêm SafeExamBrowser hash:", err);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const currentUrl = new URL(window.location.href);

axiosConfigV2.interceptors.response.use(
  async (response) => {
    if (currentUrl.pathname.replace(/^\//, "") === routesConfig.maintenance) {
      window.history.length > 2
        ? window.history.back()
        : (window.location.href = "/");
    }
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;
    if (!prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfigV2(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (error?.response?.status === 400) {
      notifyError(error.response.data.message);
    } else if (error?.response?.status === 401) {
      // unauthorize
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 503) {
      //server down
      const logout = useAuthStore.getState().logout;
      logout();
      return Promise.reject(error);
    } else if (error?.response?.status === 500) {
      message.error(
        error.response.data.message ||
          "Hệ thống bị gián đoạn vui lòng quay lại sau."
      );
    } else if (error?.response?.status === 403) {
      message.error(
        error.response.data.message ||
          "Hệ thống bị gián đoạn vui lòng quay lại sau."
      );
    } else if (error?.response?.status === 502) {
      if (currentUrl.pathname !== "/" + routesConfig.maintenance) {
        currentUrl.pathname = "/maintenance";
        window.location.href = currentUrl.href;
      }
    }
    return Promise.reject(error);
  }
);
